import { useState, useEffect } from 'react';

// Validators
import { FormsValidator } from '../validators';

export const useValidatorFormDetail = (pageConfig, amount, forcedMin, forcedMax) => {

    const inputs = {

        amount: 'amount'
    };

    const [validation, setValidation] = useState({ summary: null, formValid: false, formComplete: false });

    useEffect(() => {
        
        const validations = FormsValidator.summary([
            () => FormsValidator.required(pageConfig, amount, inputs.amount),
            () => FormsValidator.min(pageConfig, amount, inputs.amount, forcedMin),
            () => FormsValidator.max(pageConfig, amount, inputs.amount, forcedMax),
            () => FormsValidator.maxDecimals(pageConfig, amount, inputs.amount, forcedMax),
        ]);

        setValidation({
            summary: validations.filter(v => !v.valid),
            formValid: validations.formValid,
            formComplete: amount > 0
        });

    }, [amount]);

    return { validation, inputs };
};